import { InputComponentProps } from "./Filters";
import { Display_Value_Key as dvk } from "../Create/utils";

import { useEffect, useState } from "react";

// Single select (dropdown) input component
const RenderSingleSelect: React.FC<InputComponentProps> = ({
  filter,
  options = [],
  onChange,
  preSelected,
  onApplyStateChange,
}) => {
  const [selectedValue, setSelectedValue] = useState<string>("");

  useEffect(() => {
    if (preSelected[filter.name])
      setSelectedValue(preSelected[filter.name] + dvk);
  }, [filter, preSelected]);

  const handleApply = () => {
    onChange(filter.name, selectedValue, "hisingle");
  };

  // Update apply state whenever selectedValue changes
  useEffect(() => {
    if (onApplyStateChange) {
      onApplyStateChange(!selectedValue, handleApply, "Apply");
    }
  }, [selectedValue, onApplyStateChange]);

  return (
    <div>
      <select
        className="form-select"
        value={selectedValue}
        onChange={(e) => setSelectedValue(e.target.value)}
      >
        <option value="">Select an option</option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {/* <div className="d-flex justify-content-end">
        <button
          className="btn btn-primary"
          disabled={!selectedValue}
          onClick={() => onChange(filter.name, selectedValue, 'hisingle')}
        >
          Apply
        </button>
      </div> */}
    </div>
  );
};

export default RenderSingleSelect;
